export const renterTheme = {
  tablist: {
    base: '',
    // base: 'p-2 grid grid-cols-1 ',
    styles: {
      default: '',
    },

    tabitem: {
      base:
        `
        text-[#e44131] 
        hover:bg-[#b93527] 
        hover:text-white 
        shadow-md 
        transition-shadow 
        duration-200
      `,
      styles: {
        default: {
          active: { on: 'text-white bg-redPrimary hover:bg-[#b93527] hover:border-none', off: 'border-t-[#e44131]  border-l-[#e44131] hover:border-none' }, // Ajuste para objeto com propriedades 'on' e 'off'
        },
      },
      // icon: "mr-2 min-h-6 h-6 w-6"
    },
  },
  // tabpanel: 'p-4 bg-gray-50 dark:bg-gray-800',
};
